import { useTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';
import { Button } from 'components/Button';
import { ExpressablesFooter } from 'components/Layout/AuthenticationLayout';
import { Heading, Paragraph } from 'components/Typography';
import { useNavigation } from 'utils/hooks/useNavigation';
import { BasicHeader } from 'components/Layout/BasicHeader';

// A paged user when there's issues with the logged in user, with a button to log out of the broken user
export const UserErrorPage = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  return (
    <main id="maincontent" tabIndex={-1} className="flex flex-col flex-grow bg-cream-50 max-w-[100vw]">
      <BasicHeader />
      <div className="flex flex-col items-center max-w-[600px] m-auto pt-40 text-center">
        <Heading level="h2" as="h1" className="whitespace-pre-wrap">
          {t('appError.pageHeading')}
        </Heading>
        <Paragraph className="mt-8">{t('appError.helperText')}</Paragraph>

        <Button
          className="mt-40"
          size="lg"
          onClick={async () => {
            await Auth.signOut();
            navigate('/');
          }}
        >
          {t('appError.returnToLoginButtonText')}
        </Button>
      </div>
      <ExpressablesFooter />
    </main>
  );
};
